<template>
    <div>
        <LabelList :type="type"></LabelList>
    </div>
</template>

<script>
    import LabelList from './components/labelList';

    export default {
        name: "Product",
        components: {
            LabelList
        },
        data() {
            return {
                type:"PRODUCT_LABEL"
            };
        }
    }
</script>

<style lang="less" scoped>

</style>